import script from "./BaseFlexTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseFlexTable.vue?vue&type=script&setup=true&lang=ts"

import "./BaseFlexTable.vue?vue&type=style&index=0&id=14732c1e&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14732c1e"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
